import React from 'react';
import Banner1 from '../assets/img/pexels-banner.png';
import Banner2 from '../assets/img/pexels-banner3.png';
import Banner3 from '../assets/img/pexels-banner4.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
const responsive = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 1,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 1,
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 1,
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
	},
};
function HomeCarousel() {
	return (
		<div>
			<Carousel
				className='custom__carousel'
				responsive={responsive}
				infinite
				autoPlay={true}
				autoPlaySpeed={2000}
			>
				<div className='slide1 d-flex'>
					<img
						src={Banner2}
						alt='Banner2'
						className='ml-auto img-fluid'
					/>
				</div>
				<div className='slide2 d-flex'>
					<img
						src={Banner1}
						alt='Banner1'
						className='ml-auto img-fluid'
					/>
				</div>
				<div className='slide3 d-flex'>
					<img
						src={Banner3}
						alt='Banner3'
						className='ml-auto img-fluid'
					/>
				</div>
			</Carousel>
		</div>
	);
}

export default HomeCarousel;
